module.exports = __webpack_public_path__ + "img/00_Habilitaciones - MINISTEIRO DE SALUD.4796648e.png";